import { render } from "./EditMaterialForm.vue?vue&type=template&id=e60a3c74"
import script from "./EditMaterialForm.vue?vue&type=script&lang=js"
export * from "./EditMaterialForm.vue?vue&type=script&lang=js"

import "./EditMaterialForm.vue?vue&type=style&index=0&id=e60a3c74&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__